import { files, goodCausesRef } from "@/fireinit.js";
import axios from "axios";
import Vue from "vue";

export default {
  loadAll: async ({ commit, rootState }) => {
    const response = await axios.get(
      `${rootState.axios.API}goodCause/all/available`
    );
    let goodCauseList = [];
    response.data.forEach((GC) => {
      goodCauseList.push({ ...GC });
    });
    commit("setLoading", false);
    commit("setGoodCauseList", goodCauseList);
  },
  loadAllAdmin: async ({ commit, rootState }) => {
    const response = await axios.get(`${rootState.axios.API}goodCause/all`, {
      headers: {
        Authorization: `Bearer ${rootState.user.data.auth._lat}`,
      },
    });
    let goodCauseList = [];
    response.data.forEach((GC) => {
      goodCauseList.push({ ...GC });
    });
    commit("setLoading", false);
    commit("setGoodCauseList", goodCauseList);
  },
  delete: async ({ commit, rootState, dispatch }, ID) => {
    let updateGoodCause = await axios.post(
      `${rootState.axios.API}goodCause/delete`,
      {
        id: ID,
      },
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    dispatch("loadAllAdmin");
  },
  loadProfile: async ({ commit, state, rootState }, id) => {
    let goodCauseFromState = state.list.find((gc) => {
      return gc.id === id; //Return Business if ==
    });
    let goodCause = {};
    if (typeof goodCauseFromState === "undefined") {
      const response = await axios.get(`${rootState.axios.API}goodCause/${id}`);
      goodCause = response.data[0];
    } else {
      goodCause = goodCauseFromState;
    }
    commit("setCurrentProfile", goodCause);
  },
  save: async ({ commit, rootState, dispatch }, goodCause) => {
    if (goodCause.id) {
      let image = null;
      if (goodCause.image) {
        image = goodCause.image;
        delete goodCause.image;
      }
      if (image) {
        let file = image.file;
        const metadata = {
          contentType: file.type,
        };
        let imageFile = await files
          .child("goodCauseImages/" + goodCause.id)
          .put(file, metadata);
        let downloadUrl = await imageFile.ref.getDownloadURL();
        goodCause.imageUrl = downloadUrl;
      }
      goodCause.firebase_id = null;
      let updateGoodCause = await axios.post(
        `${rootState.axios.API}goodCause/update`,
        goodCause,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Save Successful",
        text: "Good Cause has successfully been saved",
      });

      return goodCause;
    } else {
      let createGoodCause = await axios.post(
        `${rootState.axios.API}goodCause/create`,
        goodCause,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      Vue.notify({
        type: "success",
        duration: 3000,
        title: "Creation Successful",
        text: "Good Cause has successfully been created",
      });
      let goodCause_id = createGoodCause.data.goodCauseID;
      let response = await axios.get(
        `${rootState.axios.API}goodCause/${goodCause_id}`,
        {
          headers: {
            Authorization: `Bearer ${rootState.user.data.auth._lat}`,
          },
        }
      );
      goodCause = response.data[0];
      dispatch("loadAllAdmin");
      return { ...goodCause };
    }
  },
  saveWorkItemImage: async ({ commit }, workItem) => {
    if (workItem.image) {
      let file = workItem.image.file;
      const metadata = {
        contentType: file.type,
      };
      let imageFile = await files
        .child(`workItemImages/${workItem.goodCause_id}_${workItem.idx}`)
        .put(file, metadata);
      let downloadUrl = await imageFile.ref.getDownloadURL();
      return downloadUrl;
    }
  },
  createLogin: async ({ commit, dispatch }, goodCause) => {
    if (goodCause.uid) {
      dispatch("notification/alert", "Good Cause already has a ");
    }
  },
  requestIBCreation: async ({ commit, dispatch, rootState }, payload) => {
    await axios.post(
      `${rootState.axios.API}goodCause/requestIBCreation`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );

    Vue.notify({
      type: "success",
      duration: 3000,
      title: "Request Sent",
      text: "UpstreamNZ will have a look into creating this Impact Buyer",
    });
  },
};
